import React from "react";
import "../../css/ContentSection.css";
import Button from "./Button";

const renderLines = (text) => {
  if (!text) return null;
  const lines = text.split("\n");
  return lines.map((line, index) => (
    <React.Fragment key={index}>
      {line}
      {index < lines.length - 1 ? <br /> : null}
    </React.Fragment>
  ));
};

function ContentSection({
  id,
  title,
  paragraphs = [],
  image,
  imageAlt = "",
  imagePosition = "right", // 'left' or 'right'
  buttonText,
  buttonAction,
  showDivider = false,
  backgroundColor = "light", // 'light' or 'dark'
  className = "",
  onClick,
  url,
  helperText,
}) {
  return (
    <section
      className={`content-section ${backgroundColor} ${className}`}
      id={id}
    >
      <div
        className={`${image ? "content-container" : "text-button-container"}`}
      >
        {/* <div className="content-container"> */}
        {imagePosition === "left" && image && (
          <div className="content-image image-left">
            <img src={image} alt={imageAlt} />
          </div>
        )}

        <div
          className={`content-text 
        ${image ? "left" : "center"} 
        `}
          style={{
            maxWidth: 1200,
          }}
        >
          {title && <h2>{title}</h2>}
          {showDivider && <div className="content-divider"></div>}
          {paragraphs.map((paragraph, index) => (
            <p key={index}>{renderLines(paragraph)}</p>
          ))}
          {helperText && <p className="content-helper-text">{helperText}</p>}
          {buttonText && <Button text={buttonText} onClick={onClick} />}
        </div>

        {imagePosition === "right" && image && (
          <div className="content-image image-right">
            <img src={image} alt={imageAlt} />
          </div>
        )}
      </div>
    </section>
  );
}

export default ContentSection;
